const PartnerData = [
    {
        _id: '1',
        brand: 'Molemab',
        url: 'molemab',
        description: 'MolemabSpa(이태리)는 1961년부터 고성능 비트리본드 CBN & Diamond 휠 및 일반 연마지석을 생산하는 업체로 작업의 효율성을 극대화 하기위해 CF(Carbon Fiber), 스틸, 초경 및 특수소재 등의 다양한 휠 바디와 샹크로 제작한 초정밀, 고성능 연마휠을 생산하고 있습니다.',
        image: 'molemab',
        image_height: '100px',
        image_width: '226px',
        type: 'abrasive',
        className: 'object-fit',
        partner_url: 'https://www.molemab.com/',
        image_upper_path: 'molemab_images',
        image_cover_path: 'molemab_type_images',
        //Individual product details
        products: [
            {
                _id: 'molemab_1',
                name: 'Surface Grinding Wheels / 평면연마',
                type: '평면연마',
                url: 'molemab',
                type_url: 'surface',
                type_image: 'molemab_surface_cover',
                description: '평면 연마 작업은 평평한 표면을 연마기를 사용하여 지속적이고 정확하게 갈아버리는 형태로 수행됩니다. 작업 종류는 수평 또는 수직의 스핀들, 트래버스 또는 회전연마 기계의 작업이 포함됩니다.',
                details: [
                    {
                        name: '수평식 스핀들 연마기계용 연마 휠 (Straight wheels for surface grinding machines with horizontal spindle)',
                        image: '/images/product_images/molemab_images/molemab_surface/molemab_surface_grinding_1.jpg',
                        alt: 'molemab_1',
                        type: 'surface_grinding_wheels',
                        description: '수평 스핀들 연마기계는 연강, 열처리강 및 고합금 등등의 다양한 소재들을 작업할 때 적합 합니다. Molemab은 각 소재및 작업에 적합한 최고 성능의 다양한 크기와 사양의 연마휠 공급합니다.',
                    },
                    {
                        name: '수직식 스핀들 연마기계용 연마 휠 (Rings or cylindrical cup wheels)',
                        image: '/images/product_images/molemab_images/molemab_surface/molemab_cylindrical_wheels.jpg',
                        alt: 'molemab_2',
                        type: 'surface_grinding_wheels',
                        description: '수직 스핀들이 장착된 연마 기계에 사용하는 이러한 형태의 연마석은 건식 혹은 습식 연마가 가능합니다.'
                    },
                    {
                        name: '사각 평면 연마석 (Abrasive segments for surface grinding)',
                        image: '/images/product_images/molemab_images/molemab_surface/molemab_flat.jpg',
                        alt: 'molemab_3',
                        type: 'surface_grinding_wheels',
                        description: '특수 다공구조와 첨가제 및 본드로 제작되는 연마석은 어떠한 소재의 연마에도 최고의 성능을 제공합니다. 레진본드및 비트리본드 지석 모두 공급 합니다.'
                    }
                ],
            },
            {
                _id: 'molemab_2',
                name: 'Cylindrical Grinding Wheels',
                type: '원통연마',
                url: 'molemab',
                type_url: 'cylindrical',
                type_image: 'molemab_cylindrical_cover',
                description: '원통연마는 원형소재의 완벽한 기하학적의 원형형상및 면조도를 얻기위한 연마작업 입니다.',
                details: [
                    {
                        name: '좌우이송방식(through feed) 원통연마',
                        image: '/images/product_images/molemab_images/molemab_cylindrical/molemab_through_feed_cylindrical_wheels.jpg',
                        alt: 'molemab_1',
                        type: 'cylindrical_grinding_wheels',
                        description: 'Molemab사의 좌우이송식 연마휠은 고내열강, 내마모강, 스텐레스강, 열처리강등등의 다양한 소재에 최적의 작업성을 제공 합니다.',
                    },
                    {
                        name: '앞뒤이송방식(plunge) 원통연마',
                        image: '/images/product_images/molemab_images/molemab_type_images/molemab_cylindrical_cover.jpg',
                        alt: 'molemab_2',
                        type: 'cylindrical_grinding_wheels',
                        description: '공작물에 평행하게 전진하여 연마를 하는 플런지 방식의 원통연마는 원뿔스핀들등의 형상이 있는 원형제품의 원통연마에 적용 합니다.',
                    },
                    {
                        name: '크랑크샤프트(crankshafts)와 캠샤프트(camshafts) 원통연마',
                        image: '/images/product_images/molemab_images/molemab_cylindrical/molemab_crankshafts_camshafts.jpg',
                        alt: 'molemab_3',
                        type: 'cylindrical_grinding_wheels',
                        description: '엔진부품인 크랑크샤프트와 캠샤프트의 원통연마는 보통 35 m/sec로 작업 합니다. 열처리된 강이나 주물, 크롬코팅된 소재등등의 원통연마작업에 사용 합니다.',
                    },
                ],
            },
            {
                _id: 'molemab_3',
                name: 'Internal Grinding Wheels/내경연마 휠',
                type: '내경연마 휠',
                type_image: 'molemab_internal_cover',
                url: 'molemab',
                type_url: 'internal',
                description: '원통이나 원뿔형의 열처리강, 스텐레스 등등의 다양한 소재 공작물의 내경연마에 사용합니다.',
                details: [
                    {
                        name: 'Internal (I.D.) Grinding Wheels / 내경연마 휠',
                        image: '/images/product_images/molemab_images/molemab_internal/molemab_internal.jpg',
                        alt: 'molemab_1',
                        type: 'surface_grinding_wheels',
                        description: '',
                    }
                ],
            },
            {
                _id: 'molemab_4',
                name: 'Gear Grinding Wheels/기어연마 휠',
                type: '기어연마 휠',
                type_image: 'molemab_gear_cover',
                url: 'molemab',
                type_url: 'gear',
                description: '스퍼웜, 싱글등 다양한 형태의 다양한 기어연마작업용 휠.  특히, 펌프(pumps)와 페라리엔진(oleodynamic engines)의 기어연마에 공급하고 있습니다.',
                details: [
                    {
                        name: 'Special profile wheels T1 – T1 SPIR',
                        image: '/images/product_images/molemab_images/molemab_gear/molemab_special_profile.jpg',
                        alt: 'molemab_1',
                        type: 'gear_grinding_wheels',
                        description: 'Molemab사의 다양한 형상및 크기의 spir wheels',
                    },
                    {
                        name: 'Single Profile Wheels T1 - PRQ',
                        image: '/images/product_images/molemab_images/molemab_gear/molemab_single_profile.jpg',
                        alt: 'molemab_2',
                        type: 'gear_grinding_wheels',
                        description: 'Molemab사의 싱글(single profile)휠의 63 m/sec 사용주속의 연마휠',
                    },
                    {
                        name: 'Grinding gears for pumps and oleodynamic engines Forme T1 – PRN',
                        image: '/images/product_images/molemab_images/molemab_gear/molemab_gears_for_pumps.jpg',
                        alt: 'molemab_3',
                        type: 'gear_grinding_wheels',
                        description: 'Molemab사는 펌프및 오레오다이나믹엔진(oleodynamic engines) 기어연마를 위한 다양한 형상의 연마휠을 공급 합니다.',
                    },
                ],
            },
            {
                _id: 'molemab_5',
                name: 'Centerless Grinding Wheels/센터레스연마 휠',
                type: '센터레스연마 휠',
                type_image: 'molemab_centerless_cover',
                url: 'molemab',
                type_url: 'centerless',
                description: '센터리스연마는 크기가 다른 연마석과 조정석(러버본드 혹은 스틸 드럼)으로 구성이 되어 다양한 소재의 원형을 연마하는 작업 입니다.',
                details: [
                    {
                        name: '휠 형상 T1 – T5 – T7',
                        image: '/images/product_images/molemab_images/molemab_type_images/molemab_centerless_cover.jpg',
                        alt: 'molemab_1',
                        type: 'centerless_grinding_wheels',
                        description: '일반적으로 연마기계에 따라 T1, T5, T7등 3가지 형상의 연마휠을 사용 합니다.',
                    },
                    {
                        name: '조정석',
                        image: '/images/product_images/molemab_images/molemab_centerless/molemab_regulating.jpg',
                        alt: 'molemab_2',
                        type: 'centerless_grinding_wheels',
                        description: '조정석은 연마휠에 비해 작고 천천히 회전하여 그 회전비에 의해 공작물을 잡아주는 역할과 면조도및 원형도를 유지시켜주는 중요한 휠 입니다.',
                    },
                    {
                        name: 'Through feed centerless grinding/스루피드 센터리스연마휠',
                        image: '/images/product_images/molemab_images/molemab_centerless/molemab_through_feed.jpg',
                        alt: 'molemab_2',
                        type: 'centerless_grinding_wheels',
                        description: '스루피드(through feed) 센터리스 연마휠은 연철, 고합금, 경화강, 크롬코팅등 다양한 소재의 연마작업에 사용 합니다. 또한, 캠샤프트 등의 플런지(plunge)센터리스 작업용의 다양한 연마휠도 개발, 공급 합니다.',
                    },
                ],
            },
            {
                _id: 'molemab_6',
                name: 'Tool Sharpening Wheels/공구 연마용 휠',
                type: '공구 연마용 휠',
                url: 'molemab',
                type_url: 'tool_sharpening',
                type_image: 'molemab_tool_cover',
                description: '고속도강 공구및 다양한 공구소재의 연마를 위한 컵휠 등등의 다양한 형상의 공구연마용 휠을 생산 합니다.',
                details: [
                    {
                        name: 'Working wheels shapes T1 – T5 – T7',
                        image: '/images/product_images/molemab_images/molemab_tool/molemab_tool.jpg',
                        alt: 'molemab_1',
                        type: 'tool_sharpening_wheels',
                        description: 'Molemab catalogue offers a wide range of sharpening wheels available in different shapes: straight wheels, dish wheels, cylindrical or flaring cups . For sharpening band and circular saw blades Molemab has developed special specifications which provide higher performances compared to the standard qualities available on the market.',
                    },
                ],
            },
            {
                _id: 'molemab_7',
                name: 'Bench Grinding Wheels/벤치 연마휠',
                type: '벤치 연마휠',
                url: 'molemab',
                type_url: 'bench',
                type_image: 'molemab_bench_cover',
                description: '벤치 연마휠은 많은 작업에 흔히 쓰이는 아이템 입니다.',
                details: [
                    {
                        name: 'Wheels for pedestal and bench grinding machines',
                        image: '/images/product_images/molemab_images/molemab_bench/molemab_bench.jpg',
                        alt: 'molemab_1',
                        type: 'bench_grinding_wheels',
                        description: '일반적으로 35 m/sec의 속도에서 작업이 되는 다양한 형상의 벤치 연마휠을 생산 합니다.',
                    },
                ],
            },
            {
                _id: 'molemab_8',
                name: 'Diamond Dressing Tools/다이아몬드 드레서',
                url: 'molemab',
                type_url: 'diamond',
                type: '다이아몬드 드레서',
                type_image: 'molemab_diamond_cover',
                description: '최상의 연마작업성을 얻기 위해서는 드레서의 역할이 매주 중요 합니다. 고급질의 천연다이아와 인조다이아로 제조된 다양한 형상의 초정밀 규격의 드레서를 생산 합니다.',
                details: [
                    {
                        name: 'Diamond dressing tools',
                        image: '/images/product_images/molemab_images/molemab_type_images/molemab_diamond_cover.jpg',
                        alt: 'molemab_1',
                        type: 'diamond_dressing_tools',
                        description: '',
                    },
                ],
            },
            {
                _id: 'molemab_9',
                name: 'CBN Vitrified Bonded Wheels',
                type: 'CBN Vitrified Bonded Wheels',
                type_image: 'molemab_cbn_cover',
                url: 'molemab',
                type_url: 'cbn',
                description: 'Molemab offers a wide range of high quality vitrified diamond and CBN wheels. In our laboratories we have developed many different bonds to achieve the best performances in any application.',
                details: [
                    {
                        name: 'Vitrified Diamond and CBN wheels for the automotive industry',
                        image: '/images/product_images/molemab_images/molemab_cbn/molemab_automotive_cbn.jpg',
                        alt: 'molemab_1',
                        type: 'cbn_grinding_wheels',
                        description: 'The precision requested to achieve the best performances in the automotive industry has been one of the most important challenges for Molemab, and now we are proud to say that we are one of the main suppliers in this field. Fuel injection systems, CV joint grinding, crank and camshafts, bearings and many others are parts needed in the automotive industry which can be manufactured at the best in precision and tolerances when using Molemab vitrified diamond and CBN wheels.',
                    },
                    {
                        name: 'Vitrified Diamond and CBN wheels for internal grinding',
                        image: '/images/product_images/molemab_images/molemab_cbn/molemab_internal_cbn.jpg',
                        alt: 'molemab_2',
                        type: 'cbn_grinding_wheels',
                        description: 'In such applications, for example Ball Nut Grinding, precision profiles need to be generated under severe conditions. Tipically, limited coolant access leading to elevated risk of workpiece burn, can make these very challenging applications. Careful choice of the CBN crystal structure combined with latest vitrified bond developments have enabled Molemab to become a world leader in this demanding application.',
                    },
                ],
            },
            {
                _id: 'molemab_10',
                name: 'Resinoid, Metal and Hybrid Bonded DIA/CBN Wheels',
                type: 'Resinoid, Metal and Hybrid Bonded DIA/CBN Wheels',
                type_image: 'molemab_metal_cbn_cover',
                url: 'molemab',
                type_url: 'resinoid_cbn',
                description: 'The wide range of Molemab products comprises also resin and metal bonded Diamond and CBN grinding wheels ideal to be used in cutting tools production on CNC machines .',
                details: [
                    {
                        name: 'Diamond and CBN wheels for metal working industry',
                        image: '/images/product_images/molemab_images/molemab_resinoid/molemab_cbn_resinoid.jpg',
                        alt: 'molemab_1',
                        type: 'cbn_resinoid_wheels',
                        description: 'Molemab can provide different types of Diamond and CBN wheels for metal working:',
                        sub_descriptions: [
                            'Forte 1D is a Diamond wheel made with a special Metal Bond which combines a very high cutting ability with a tough resistance to the wheel wear;',
                            'Forte 1B is a Diamond wheel made with a special Metal Bond which combines a very high cutting ability with a tough resistance to the wheel wear;',
                            'FORTEpro includes Diamond and CBN wheels made with a special Hybrid Bond which combines very strong cutting ability with a tough resistance to the wheel wear;',
                            'FORTEpro “POROUS":” in this range we have Hybrid Bonded Diamond and CBN wheels. The Hybrid Bond has been further improved increasing the lubrication ability of the wheel when working, reducing the power consumption and the risk ov overheat in the tool.'
                        ]
                    },
                    {
                        name: 'Polygloss Diamond and CBN wheels',
                        image: '/images/product_images/molemab_images/molemab_resinoid/molemab_polygloss_cbn.jpg',
                        alt: 'molemab_2',
                        type: 'cbn_resinoid_wheels',
                        description: 'Molemab presents Polygloss wheels, one of the last grinding wheels generation, designed and manufactured for the mirror finishing of tools flutings and cutting edges. Using tools with lapped flutings and cutting edges grants big advantages when working aluminium, copper and brass, titanium, plastics and laminated materials. Other big advantages using these wheels are the optimization of the flutings and cutting tools geometry, the lack of faults on the cutting edges, a faster chip removal and the reduction of power consumption of the machine.',
                    },
                    {
                        name: 'Diamond and CBN wheels for wood working industry',
                        image: '/images/product_images/molemab_images/molemab_resinoid/molemab_wood_cbn.jpg',
                        alt: 'molemab_3',
                        type: 'cbn_resinoid_wheels',
                        description: 'Molemab produces wheels for sharpening tools used in the woodworking industry, such as circular and band saws, knives, etc. For any specific sharpening operation we can provide the right shape, size and specification, achieving with our quality the best results.',
                    },
                ],
            },
            {
                _id: 'molemab_11',
                name: 'Cutting and Grinding Discs',
                type: 'Cutting and Grinding Discs',
                type_image: 'molemab_cutting_cover',
                url: 'molemab',
                type_url: 'discs',
                description: 'Molemab products range includes also cut-off and grinding discs in different qualities for steel, stainless steel, cast iron, aluminium and non ferrous metals. The range is completed by flap discs and wheels and other products suitable for surface finishing.',
                details: [
                    {
                        name: 'Cut-off and grinding discs',
                        image: '/images/product_images/molemab_images/molemab_resinoid/molemab_cut_off.jpg',
                        alt: 'molemab_1',
                        type: 'cutting_grinding_discs',
                        description: 'Molemab cut-off and grinding discs are suitable for many different applications. Flat cutting discs are used on fix and portable machines, depressed centre grinding discs are used on hand portable grinders. Four different ranges are available for different applications and working conditions:',
                        sub_descriptions: [
                            'GEO: general purpose for professional use. They are the perfect balance for fast cut, high stock removal and life time, reducing the costs.',
                            'CRONO: high performances for professional use. Very fast cut and stock removal combined with long life time. These discs do not contain iron oxide, sulphur and chlorine. They are suitable for stainless and high alloyed steel, where it’s requested the non contamination and non oxidation of the metal.',
                            'URANO: top quality products for high professional use in foundries, steel factories, pipe mills, oil and gas pipelines, big metal and railway constructions. Made with the highest quality raw materials which provide the best cutting ability.',
                            'CRIO: standard range for sales in hardware stores and large distribution. They are a good compromise between cheap cost and good performances, always fully respecting the safety rules.'
                        ]
                    },
                    {
                        name: '2. Flap discs and wheels',
                        image: '/images/product_images/molemab_images/molemab_resinoid/molemab_flap_disc.jpg',
                        alt: 'molemab_2',
                        type: 'cutting_grinding_discs',
                        description: 'Molemab flap wheels and discs are suitable for grinding with angle and axial machines. Depending on the application wheels and discs may have different shapes and bodies. They can be flat or tapered with fibreglass backing and flat with plastic or reinforced nylon backing.',
                    },
                ],
            },
            {
                _id: 'molemab_12',
                name: 'Mounted points and carbide burrs',
                type: 'Mounted points and carbide burrs',
                type_image: 'molemab_burr_cover',
                url: 'molemab',
                type_url: 'burr',
                description: 'Molemab offers a wide range of abrasive tools for grinding and surface finishing. They are available in many shapes and sizes, different abrasive types and grit size and top performing bonds. We can also profide special taylor made products designed according to customers’ needs.',
                details: [
                    {
                        name: '1. Mounted points and wheels',
                        image: '/images/product_images/molemab_images/molemab_burr/molemab_mounted.jpg',
                        alt: 'molemab_1',
                        type: 'burr',
                        description: 'Molemab produces mounted points and wheels for snagging and grinding steel, cast iron and stainless steel:',
                        sub_descriptions: [
                            'Shape: wheels can be cylindrical or shaped with shank diameter 6 mm o 3 mm',
                            'Abrasive: pink aluminium oxide for general purpose on different types of steel, special mix f grey and pink aluminium oxide for casting and foundries',
                            'Bond: vitrified or resinoid.',
                        ]
                    },
                    {
                        name: '2. Carbide burrs',
                        image: '/images/product_images/molemab_images/molemab_burr/molemab_carbide.jpg',
                        alt: 'molemab_2',
                        type: 'burr',
                        description: 'Molemab can provide special carbide burrs designed to make snagging and surface finishing easier. Thanks to the wide range of sizes, shapes and types they can be used for finishing surfaces and profiles, snagging and remove bead welding. The peculiar advantages of Molemab carbide burrs are the fast stock removal, the excellent surface finishing, the low vibrations level generated while working and the effective chip clearance.',
                    },
                ],
            },
        ]
    },
    {
        _id: '2',
        brand: 'GYSL',
        url: 'gysl',
        description: 'GYSL(중국)은 1998년부터 유럽의 연마지석 생산 업체들에게 비트리 연마지석을 OEM 생산으로 공급하고 있습니다. 축적된 유럽표준 생산시스템 및 고성능 지석 생산기술을 바탕으로 일정한 성능의 고품질 연마지석을 생산하고 있으며 특히, 고품질 저온 열처리 본드로 생산된 고성능 지석과 다공성 지석을 경쟁력 있는 가격으로 생산하고 있습니다.',
        image: 'gysl',
        type: 'abrasive',
        image_height: '140px',
        image_width: '150px',
        className: 'object-fit',
        partner_url: 'http://www.gysl.com/',
        image_upper_path: 'gysl_images',
        image_cover_path: 'gysl_type_images',
        products: [
            {
                _id: 'gysl_1',
                name: '3NG, 5NG 세라믹 연마지석',
                type: '3NG, 5NG 세라믹 연마지석',
                type_image: 'gysl_ceramic',
                url: 'gysl',
                type_url: 'ceramic',
                description: 'SKD11, 고속도강, Stainless 등등의 다양한 소재의 연마 작업에 일반 WA 지석에 비해 5 ~ 10 배의 연삭성능 및 수명을 보장합니다.',
                details: [
                    {
                        name: '3NG, 5NG 세라믹 연마지석',
                        image: '/images/product_images/gysl_images/gysl_type_images/gysl_ceramic.jpg',
                        alt: 'gysl_1',
                        type: 'ceramic',
                        description: '3NG(30% Ceramic) / 5NG(50% Ceramic)',
                        sub_descriptions_title: '생산제품 범위',
                        sub_descriptions: [
                            'Diameter: 10mm ~ 1300mm',
                            'Thickness: 2mm ~ 430mm',
                            'Grain size: #16 ~ #400',
                            'Maximum operating speed: 35 ~ 80 M/S',
                            'Dimensions tolerance : +/- 0.05mm'
                        ]
                    }
                ],
            },
            {
                _id: 'gysl_2',
                name: '기어 연마지석',
                type: '기어 연마지석',
                type_image: 'gysl_gear',
                url: 'gysl',
                type_url: 'gear',
                description: 'Molemab offers a wide range of abrasive tools for grinding and surface finishing. They are available in many shapes and sizes, different abrasive types and grit size and top performing bonds. We can also profide special taylor made products designed according to customers’ needs.',
                details: [
                    {
                        name: '기어 연마지석',
                        image: '/images/product_images/gysl_images/gysl_type_images/gysl_gear.jpg',
                        alt: 'gysl_2',
                        type: 'gear',
                        description: 'Molemab produces mounted points and wheels for snagging and grinding steel, cast iron and stainless steel:',
                        sub_descriptions_title: '생산제품 범위',
                        sub_descriptions: [
                            'Diameter: 10mm ~ 1300mm',
                            'Thickness: 2mm ~ 430mm',
                            'Grain size: #16 ~ #400',
                            'Maximum operating speed: 35 ~ 80 M/S',
                            'Dimensions tolerance : +/- 0.05mm'
                        ]
                    }
                ],
            },
            {
                _id: 'gysl_3',
                name: '센타리스, 원통, 외경 및 내경 연마지석',
                type: '센타리스, 원통, 외경 및 내경 연마지석',
                type_image: 'gysl_centerless',
                url: 'gysl',
                type_url: 'centerless',
                description: 'Molemab offers a wide range of abrasive tools for grinding and surface finishing. They are available in many shapes and sizes, different abrasive types and grit size and top performing bonds. We can also profide special taylor made products designed according to customers’ needs.',
                details: [
                    {
                        name: '센타리스, 원통, 외경 및 내경 연마지석',
                        image: '/images/product_images/gysl_images/gysl_type_images/gysl_centerless.jpg',
                        alt: 'gysl_3',
                        type: 'centerless',
                        description: 'Molemab produces mounted points and wheels for snagging and grinding steel, cast iron and stainless steel:',
                        sub_descriptions_title: '지석 규격',
                        sub_descriptions: [
                            'WA 120 H 5 V',
                            'WA 150 H 5 V',
                            'WA 180 H 5 V',
                            'WA 240 H 5 V',
                            'WA 320 H 5 V',
                        ],
                    }
                ],
            },
            {
                _id: 'gysl_4',
                name: 'LM 가이드 연마지석',
                type: 'LM 가이드 연마지석',
                type_image: 'gysl_lm',
                url: 'gysl',
                type_url: 'lm',
                description: 'Molemab offers a wide range of abrasive tools for grinding and surface finishing. They are available in many shapes and sizes, different abrasive types and grit size and top performing bonds. We can also profide special taylor made products designed according to customers’ needs.',
                details: [
                    {
                        name: '기어 연마지석',
                        image: '/images/product_images/gysl_images/gysl_type_images/gysl_lm.jpg',
                        alt: 'gysl_4',
                        type: 'lm',
                        description: 'Molemab produces mounted points and wheels for snagging and grinding steel, cast iron and stainless steel:',
                        sub_descriptions_title: '생산제품 범위',
                        sub_descriptions: [
                            'Diameter: 10mm ~ 1300mm',
                            'Thickness: 2mm ~ 430mm',
                            'Grain size: #16 ~ #400',
                            'Maximum operating speed: 35 ~ 80 M/S',
                            'Dimensions tolerance : +/- 0.05mm'
                        ]
                    }
                ],
            },
            {
                _id: 'gysl_5',
                name: '피치 / 성형 연마지석',
                type: '피치 / 성형 연마지석',
                type_image: 'gysl_pitch',
                url: 'gysl',
                type_url: 'pitch',
                description: 'Molemab offers a wide range of abrasive tools for grinding and surface finishing. They are available in many shapes and sizes, different abrasive types and grit size and top performing bonds. We can also profide special taylor made products designed according to customers’ needs.',
                details: [
                    {
                        name: '피치 / 성형 연마지석',
                        image: '/images/product_images/gysl_images/gysl_type_images/gysl_pitch.jpg',
                        alt: 'gysl_5',
                        type: 'pitch',
                        description: 'Molemab produces mounted points and wheels for snagging and grinding steel, cast iron and stainless steel:',
                        sub_descriptions_title: '지석 규격',
                        sub_descriptions: [
                            'WA 120 H 5 V',
                            'WA 150 H 5 V',
                            'WA 180 H 5 V',
                            'WA 240 H 5 V',
                            'WA 320 H 5 V',
                        ],
                        table_headers: [
                            '지석 규격',
                            '가공 홈 폭 & 코너'
                        ],
                        table_content: [
                            ['WA 120 H 5 V', '0.6 - 5.0mm(코너 R 0.05~)'],
                            ['WA 150 H 5 V', '0.5 - 3.0mm(코너 R 0.04~)'],
                            ['WA 180 H 5 V', '0.4 - 1.5mm(코너 R 0.03~)'],
                            ['WA 240 H 5 V', '0.3 - 1.0mm(코너 R 0.025~)'],
                            ['WA 320 H 5 V', '0.15 - 0.2mm(코너 R 0.02~)']
                        ]
                    }
                ],
            },
        ]
    },
    {
        _id: '3',
        brand: 'CDT',
        url: 'cdt',
        description: 'CDT(Continental Diamond Tool Corporation - 미국)은 1973년부터 비트리, 레진, 메탈, 전착본드의 고품질 다이아몬드와 CBD 연마휠 및 초정밀 로터리 드레서, 다양한 형상의 다이아몬드 드레서를 생산하고 있으며 항공우주산업, 자도아, 초경공구, 인공관절, 전기전차, 원자력발전등 첨단산업용 연마제품을 공급하고 있습니다.',
        image: 'cdt',
        type: 'abrasive',
        image_height: '100px',
        image_width: '226px',
        className: 'object-fit',
        partner_url: 'https://www.cdtusa.net/',
        image_upper_path: 'cdt_images',
        image_cover_path: 'cdt_type_images',
        //Individual product details
        products: [
            {
                _id: 'cdt_1',
                name: 'ELECTROPLATED CBN AND DIAMOND TOOLS / 전착본드 휠',
                type: '전착본드 휠',
                url: 'cdt',
                type_url: 'electro',
                type_image: 'CDT-products-electro',
                description: '초정밀로 가공된 휠에 고품질의 연마지립및 본드를 사용하여 전착된 휠은 정확한 형상, 외경, 내경 가공의 결과를 제공 합니다.',
                details: [
                    {
                        name: 'ELECTROPLATED CBN AND DIAMOND TOOLS',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-electro.jpg',
                        alt: 'cdt_1',
                        type: 'electroplated_cbn_diamonds',
                        description: '다이아몬드및 CBN전착휠은 고품질의 연마재와 니켈본드를 사용하여 연마지립의 균일한 분포, 정확한 니켈본드의 두께및 강도, 정밀 가공된샤프트는  경쟁사 대비 긴 수명및 높은 연마성능을 제공 합니다.',
                        sub_descriptions_title: 'Available Grit Sizes',
                        table_headers: ['Grit Size', 'RMS Finish', 'Grit Size', 'RMS Finish'],
                        table_content: [
                            ['20/30', '', '140/70', '32 - 48'],
                            ['30/40', '', '170/200', '24 - 32'],
                            ['40/50', '', '200/230', '20 - 24'],
                            ['60/80', '', '230/270', '16 - 20'],
                            ['80/100', '90 - 125', '270/325', '14 - 16'],
                            ['100/120', '64 - 90', '325/400', '13 - 14'],
                            ['120/140', '48 - 64', '400/500', '12 - 13'],
                        ]
                    }
                ],
            },
            {
                _id: 'cdt_2',
                name: 'METAL BOND CBN & DIAMOND TOOLS / 메탈본드 휠',
                type: '메탈본드 휠',
                url: 'cdt',
                type_url: 'metalbond',
                type_image: 'CDT-products-metalbond',
                description: 'Having the right plated grinding wheel is a must for precision grinding, contouring, scoring, facing and internal or external grinding.',
                details: [
                    {
                        name: 'METAL BOND CBN & DIAMOND TOOLS',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-metalbond.jpg',
                        alt: 'cdt_1',
                        type: 'metalbond_cbn_diamonds',
                        description: '건식및 습식작업 모두에 사용되는 메탈본드휠은 폴리싱연마부터 황삭연마까지 다양한 작업에 적용이 됩니다.  단단한 본드특성은 CNC연마기계 고성능을 발휘하고 긴 수명과 형상유지력을 제공 합니다. 단단한 금속본드로 인해 드레싱이 어려운 단점도 있습니다.',
                        sub_descriptions_title: '작업종류',
                        sub_descriptions: ['Metalworking', 'Cylindrical', 'Surface', 'Cutoff', 'Tool & Cutter']
                    }
                ],
            },
            {
                _id: 'cdt_3',
                name: 'RESIN BOND CBN & DIAMOND TOOLS / 레진본드 휠',
                type: '레진본드 휠',
                url: 'cdt',
                type_url: 'resin_bond',
                type_image: 'CDT-products-resin',
                description: 'CDT가 개발한 ResiMax™ 레진본드휠은 자생작용으로 인해 높은 연마성능과 빠른 작업시간을 제공 합니다.',
                details: [
                    {
                        name: 'RESIN BOND CBN & DIAMOND TOOLS',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-resin.jpg',
                        alt: 'cdt_1',
                        type: 'resin_bond_cbn_diamonds',
                        description: '긴수명의 ResiMax™ 휠은 연삭성능, 생산성및 긴 수명을 보장 합니다. 핫프레스(hot press)방식으로 제조되어 연마입자, 본드및 첨가재의 균일한 분포및 강도를 제공합니다.',
                        sub_descriptions_title: 'Available Grit Sizes',
                        table_headers: ['Grit Size', 'Expected Finish (RMS)', 'Maximum Depth of Cut Per Pass'],
                        table_content: [
                            ['60', '32 - 46', '0.001" - 0.002"'],
                            ['80', '24 - 32', '0.001" - 0.002"'],
                            ['100', '18 - 24', '0.001" - 0.002"'],
                            ['120', '16 - 18', '0.001" - 0.002"'],
                            ['150', '14 - 16', '0.007" - 0.001"'],
                            ['180', '12 - 14', '0.007" - 0.001"'],
                            ['220', '10 - 12', '0.005" - 0.007"'],
                            ['240', '8 - 10', '0.004" - 0.006"'],
                            ['320', '8', '0.004" - 0.006"'],
                            ['400', '6 - 8', '0.003" - 0.004"'],
                        ]
                    }
                ],
            },
            {
                _id: 'cdt_4',
                name: 'HYBRID BOND FOR TOOL GRINDING / 하이브리드본드 휠',
                type: '하이브리드본드 휠',
                url: 'cdt',
                type_url: 'hybrid_bond',
                type_image: 'CDT-products-hybrid',
                description: 'Choose Hybrid Bond for a Winning Combination',
                details: [
                    {
                        name: 'HYBRID BOND FOR TOOL GRINDING',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-hybrid.jpg',
                        alt: 'cdt_1',
                        type: 'hybrid_bond_tool_grinding',
                        description: '두가지 본드의 결합으로 제조되는 하이브리드본드 휠은 엔드밀 같은 회전공구의 플릇(Flute),개스(gash) 및 다른 부위의 연마에 뛰어난 형상유지력및 생산성은 CNC연마기계의 대량생산에 치수변화없는 연마작업을 제공합니다.',
                        sub_descriptions_title: '작업종류',
                        sub_descriptions: ['Cutting Tools', 'Endmills', 'Drills', 'Reamers']
                    }
                ],
            },
            {
                _id: 'cdt_5',
                name: 'VITRIFIED CBN & DIAMOND TOOLS / 비트리본드 휠',
                type: '비트리본드 휠',
                url: 'cdt',
                type_url: 'vtirified_cdn',
                type_image: 'CDT-products-vitrified',
                description: '세라믹본드(ceramic bond)로 제조되는 가장 강한 본드의 비트리본드 휠은 다양한 기공으로 열발생이 적고 매끄러운 균일한 연마표면을 제공 합니다..',
                details: [
                    {
                        name: 'VITRIFIED CBN & DIAMOND TOOLS',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-vitrified.jpg',
                        alt: 'cdt_1',
                        type: 'vitrified_cbn_tools',
                        description: '비트리본드 다이아몬드와 CBN휠은 강한 본드성능및 기공의 분포로 공작물의 연마와 동시에 냉각을 시켜 열발생이 적고 정밀한 형상의 연마작업을 수행 합니다. 칩핑이 적은 연마특성은 초정밀 공구의 날 부위의 수명을 연장하여 주고 열발생이 적고 높은 형상유지력은 정밀한 부품의 대량생산을 가능하게 합니다.',
                        sub_descriptions_title: '최적 작업',
                        sub_descriptions: ['Camshaft & Crankshaft', 'PCD/PCBN Cutting Tools', 'Mold & Dies', 'Turbine Blades, Vanes, Shrouds', 'Medical Instruments']
                    }
                ],
            },
            {
                _id: 'cdt_6',
                name: 'VITRIFIED DIAMOND with VIPER™ Bond Technology',
                type: 'VITRIFIED DIAMOND with VIPER™ Bond Technology',
                url: 'cdt',
                type_url: 'vtirified_diamond',
                type_image: 'CDT-products-vitrified-diamond',
                description: 'VIPER™ Bond Technology로 제조된 비트리다이아몬드(Vitrified Diamond) 와 비트리CBN(Vitrified CBN)휠은 열발생이 적은 초정밀 연마작업을 제공 합니다.',
                details: [
                    {
                        name: 'VITRIFIED CBN & DIAMOND TOOLS',
                        image: '/images/product_images/cdt_images/cdt_type_images/CDT-products-vitrified-diamond.jpg',
                        alt: 'cdt_1',
                        type: 'vitrified_diamond_tools',
                        description: 'CDT가 개발한 VIPER™ Bond Technology로 제조된 다공성의 높은 본드강도의 비트리본드 휠은 연마성능을 획기적으로 높혀주어 Silicon Carbide, Ceramics, CMC, PCD 등등의 어려운 연마소재의 연마작업을 원할하게 함과 동시에 치핑(chipping)을 감소시켜 고품질의 연마제품의 생산에 큰 역할을 합니다.',
                    }
                ],
            },
        ]
    },
    {
        _id: '4',
        brand: 'Darmann',
        url: 'darmann',
        description: 'Darmann Abrasive Products(미국)dms 1983년부터 슈퍼피니싱스톤, 호닝스톤만을 전문적으로 생산하는 업체입니다. 세계 최고 품질의 스톤제품은 많은 업체의 생산성 향상과 원가절감에 기여를 하고 있습니다. 또한, 슈퍼스톤 제작의 원천기술을 바탕으로 고성능의 비트리본드, 메탈본드 다이아몬드 / CBN 호닝스톤을 생산하고 있습니다.',
        image: 'darmann',
        type: 'abrasive',
        image_height: '100px',
        image_width: '226px',
        className: 'object-fit',
        partner_url: 'https://darmann.com/',
        image_upper_path: 'darmann_images',
        image_cover_path: 'darmann_type',
        products:[
            {
                _id: 'darmann_1',
                name: 'Superfinishing',
                type: 'Superfinishing',
                url: 'darmann',
                type_url: 'superfinishing',
                type_image: 'darmann_superfinishing',
                description: '슈퍼피니싱(Superfinishing)은 때론, 마이크로머시닝(micromachining) 혹은 짧은 스트록 호닝(short-stroke honing)이라 불리는데 낮은 연마온도와 적은 연마량으로 작업 합니다.',
                details: [
                    {
                        name: 'Superfinishing',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_superfinishing.jpg',
                        alt: 'darmann_1',
                        type: 'super_finishing',
                        description: '달만(DAP)사는 테이퍼롤러(tapered rollers), 피스톤핀(piston pins), 쇼버로드(shock absorber rods), 샤프트(shafts)및 니들(needles)의 슈퍼피니싱 작업에 사용하는 고품질 스톤을 생산 합니다.',
                        sub_descriptions_title: 'Benefits',
                        sub_descriptions: ['Increased Part Life', 'Decreased Wear Rates', 'Higher Load Bearing Surfaces', 'Quieter Performing Parts', 'Imporved Sealing Capabilities']
                    }
                ],
            },
            {
                _id: 'darmann_2',
                name: 'Flat Finishing',
                type: 'Flat Finishing',
                url: 'darmann',
                type_url: 'flat_finishing',
                type_image: 'darmann_flat',
                description: '달만(DAP)사는 트랜스미션 피니언기어(transmission pinion gears)의 평면부위등드의 경면연마에 사용하는 65 ~ 100mmD이상의 연마용 컵형상(Type 6)의 휠을 제조, 공급 합니다.',
                details: [
                    {
                        name: 'Flat Finishing',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_flat.jpg',
                        alt: 'darmann_1',
                        type: 'flat_finishing',
                        description: '달만(DAP)사는 트랜스미션 피니언기어(transmission pinion gears)의 평면부위등드의 경면연마에 사용하는 65 ~ 100mmD이상의 연마용 컵형상(Type 6)의 휠을 제조, 공급 합니다.',
                    }
                ],
            },
            {
                _id: 'darmann_3',
                name: 'Honing',
                type: '호닝스톤',
                url: 'darmann',
                type_url: 'honing',
                type_image: 'darmann_honing',
                description: '달만(DAP)사는 다양한 기계와 다양한 용도에 사용하는 비트리(vitrified)와 메탈(metal)본드 호닝스톤(honing stones)을 생산 합니다.',
                details: [
                    {
                        name: '1. Honing Stones',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_honing.jpg',
                        alt: 'darmann_1',
                        type: 'honing_stones',
                        description: '메탈본드(Metal Bond Diamond)와 일반지립(Conventional Abrasive)으로 제조된 디젤엔진의 실린더 라이너(Desel Engin Cylinder Liners)용 호닝스톤',
                    }
                ],
            },
            {
                _id: 'darmann_4',
                name: 'Dressing / 드레싱스톤',
                type: '드레싱스톤',
                url: 'darmann',
                type_url: 'dressing',
                type_image: 'darmann_dresser',
                description: 'Darmann makes vitrified and metal bonded honing stones for a wide variety of machines and applications.',
                details: [
                    {
                        name: '1. Dressing',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_dresser.jpg',
                        alt: 'darmann_1',
                        type: 'dressers',
                        description: 'Darmann offers a full line of hand held aluminum oxide and silicon carbide dressing sticks for truing and cleaning diamond and CBN abrasive wheels. Regular use of the proper dressing stick will help you achieve maximum performance from your wheel. Dressing sticks are also used by tool and die makers for polishing and removing small burrs. Available in a variety of sizes and specifications with grits ranging from 150 to 1200 FEPA.',
                        sub_descriptions_title: 'Available Grit Sizes',
                        table_headers: ['Abrasive Grit Size', 'Abrasive Grit Size', 'Resin Bond / WA', 'Resin Bond / GC', 'Vitrified Bond / WA', 'Vitrified Bond / GC'],
                        table_content: [
                            ['FEPA', 'JIS', 'WA', 'GC', 'WA', 'GC'],
                            ['4000', '10000', 'DWC60', 'DGC60', '', ''],
                            ['3000', '8000', 'DWC50', 'DGC50', '', ''],
                            ['2000', '6000', 'DWC40', 'DGC40', 'DWV40', 'DGV40'],
                            ['1200', '4000', 'DWC35', 'DGC35', 'DWV35', 'DGV35'],
                            ['1000', '3000', 'DWC30', 'DGC30', 'DWV30', 'DGV30'],
                            ['800', '2000', 'DWC20', 'DGC20', 'DWV20', 'DGV20'],
                            ['600', '1200', 'DWC12', 'DGC12', 'DWV12', 'DGV12'],
                            ['500', '1000', 'DWC10', 'DGC10', 'DWV10', 'DGV10'],
                            ['', '800', 'DWC08', 'DGC08', 'DWV08', 'DGV08'],
                            ['400', '700', 'DWC07', 'DGC07', 'DWV07', 'DGV087'],
                            ['', '600', 'DWC06', 'DGC06', 'DWV06', 'DGV06'],
                            ['360', '500', 'DWC05', 'DGC05', 'DWV05', 'DGV05'],
                            ['320', '400', 'DWC04', 'DGC04', 'DWV04', 'DGV04'],
                            ['', '320', 'DWC320', 'DGC320', 'DWV320', 'DGV320'],
                            ['240', '280', 'DWC280', 'DGC280', 'DWV280', 'DGV280'],
                            ['220', '220', 'DWC220', 'DGC220', 'DWV220', 'DGV220'],
                            ['100', '100', 'DWC100', 'DGC100', 'DWV100', 'DGV100'],
                        ]
                    }
                ],
            },
            {
                _id: 'darmann_5',
                name: 'Prosthetic Finishing / 인공관절 피니싱스톤',
                type: 'Prosthetic Finishing',
                url: 'darmann',
                type_url: 'prosthetic',
                type_image: 'darmann_prosthetic',
                description: '달만(DAP)사는 인공대퇴골(femoral ball-and-sockets)제조용 컵형(Type 6)휠 및 원통형(Type 2)휠의 생산 합니다. 업체의 요구에 이해 100mmD이상의 휠도 생산 합니다.',
                details: [
                    {
                        name: 'Prosthetic Finishing / 보철 피니싱스톤',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_prosthetic.jpg',
                        alt: 'darmann_1',
                        type: 'prosthetic_finishing',
                        description: '달만(DAP)사는 보철의 피니싱작업용 다양한 입자크기, 본드강도및 내부기공이 있는 스톤을 개발, 생산 합니다.',
                    }
                ],
            },
            {
                _id: 'darmann_6',
                name: 'Precision Grinding / 정밀연마',
                type: '정밀연마',
                url: 'darmann',
                type_url: 'precision',
                type_image: 'darmann_precision',
                description: '달만(DAP)사는 내경연마용 특수 연마휠을 생산 합니다.',
                details: [
                    {
                        name: 'Precision Grinding',
                        image: '/images/product_images/darmann_images/darmann_type/darmann_precision.jpg',
                        alt: 'darmann_1',
                        type: 'precision_finishing',
                        description: '정밀 연료노즐부품(fuel injection parts), 미니 베어링(miniature bearings), 고관절(hip implants)및 초정밀 기어(gears)연마에 사용하는 연마휠을 생산 합니다.',
                        sub_descriptions_title: '제품 종류',
                        sub_descriptions: ['Internal Grinding Wheels', 'Bore and Race Grinding Wheels', 'Miniature Wheels', 'Spindle and Quill Mounter SuperAbrasive Wheels', 'Conventional Mounted Wheels', 'Cylinder', 'One-piece and Mounted Conventional Cup Wheels', 'Continous Rim SuperAbrasive Wheels']
                    }
                ],
            },
        ]
    },
    {
        _id: '5',
        brand: 'Bay Union',
        url: 'bayunion',
        description: 'Bay Union(대만)은 1987년부터 자체 개발한 본드를 이용하여 소영 내경 연마용 비트리본드 CBN & Diamond휠 및 일반지립 연마 지석을 생산하는 업체입니다. 특히, 연료노즐 내경연마 및 치과용의 극소형 고품질 추지석을 생산합니다.',
        image: 'bay',
        type: 'abrasive',
        image_height: '100px',
        image_width: '226px',
        className: 'object-fit',
        partner_url: 'https://www.bayunion-tech.com/',
        image_upper_path: 'bayunion_images',
        image_cover_path: 'bayunion_type_images',
        products: [
            {
                _id: 'bayunion_1',
                name: '특수 연마지석',
                type: '특수 연마지석',
                url: 'bayunion',
                type_url: 'special',
                type_image: 'bay_union_special',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '특수 연마지석',
                        image: '/images/product_images/bayunion_images/bayunion_type_images/bay_union_special.jpg',
                        alt: 'bayunion',
                        type: 'surface_grinding',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                        sub_descriptions_title: '연마입자별 표준 적용 예',
                        table_headers: ['연마입자', '작업 적용'],
                        table_content: [
                            ['10A Brown Fused AO', '주철 / 비열처리강'],
                            ['20A Semi-friable AO', '탄소강 / 주철'],
                            ['30A Monocrystalline AO', '공구강 / 합금강'],
                            ['40A White AO', '모든 종류의 강'],
                            ['50A Pink AO', '공구강 / 베어링강 / 열처리강'],
                            ['60A Ruby AO', '공구강 / 열처리강 (열에 민감)'],
                            ['80A Micro-crystalline AO Blue', '고경도 합금강'],
                            ['90A Micro-crystalline AO White', '고경도 합금강'],
                            ['10C Black Silicon Carbide', '석재 / 대리석 / 고무 / 세라믹'],
                            ['20C Green Silicon Carbide', '초경합금 / 티타늄 / 비철금속'],
                        ]
                    }
                ],
            },
            {
                _id: 'bayunion_2',
                name: '외경 연마지석',
                type: '외경 연마지석',
                url: 'bayunion',
                type_url: 'outer',
                type_image: 'bay_union_outer',
                description: 'The application of grinding wheels in cylindrical grinding refers to the process of grinding the outer surface of the workpiece with grinding objects such as grinding wheels to achieve the requirements of dimensional accuracy and surface roughness. Generally speaking, most of the workpieces that need to grind the external surface have multiple angles. Therefore, a grinding machine that clamps and rotates the workpiece is often used with multiple grinding wheels of different angles for grinding operations. And BAY UNION Grinding can plan the grinding wheel specifications according to the customers on-site environment and related conditions, so that customers can be completely assured of the grinding quality after the grinding wheel is installed.',
                details: [
                    {
                        name: '외경 연마지석',
                        image: '/images/product_images/bayunion_images/bayunion_type_images/bay_union_outer.jpg',
                        alt: 'bayunion',
                        type: 'cylindrical_grinding',
                        description: 'Key factor: Precision, stability, surface roughness.',
                        sub_descriptions_title: '연마입자별 표준 적용 예',
                        table_headers: ['연마입자', '작업 적용'],
                        table_content: [
                            ['10A Brown Fused AO', '주철 / 비열처리강'],
                            ['20A Semi-friable AO', '탄소강 / 주철'],
                            ['30A Monocrystalline AO', '공구강 / 합금강'],
                            ['40A White AO', '모든 종류의 강'],
                            ['50A Pink AO', '공구강 / 베어링강 / 열처리강'],
                            ['60A Ruby AO', '공구강 / 열처리강 (열에 민감)'],
                            ['80A Micro-crystalline AO Blue', '고경도 합금강'],
                            ['90A Micro-crystalline AO White', '고경도 합금강'],
                            ['10C Black Silicon Carbide', '석재 / 대리석 / 고무 / 세라믹'],
                            ['20C Green Silicon Carbide', '초경합금 / 티타늄 / 비철금속'],
                        ]
                    }
                ],
            },
            {
                _id: 'bayunion_3',
                name: '내경 연마지석',
                type: '내경 연마지석',
                url: 'bayunion',
                type_url: 'internal',
                type_image: 'bay_union_internal',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '내경 연마지석',
                        image: '/images/product_images/bayunion_images/bayunion_type_images/bay_union_internal.jpg',
                        alt: 'bayunion',
                        type: 'internal_grinding',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                        sub_descriptions_title: '연마입자별 표준 적용 예',
                        table_headers: ['연마입자', '작업 적용'],
                        table_content: [
                            ['10A Brown Fused AO', '주철 / 비열처리강'],
                            ['20A Semi-friable AO', '탄소강 / 주철'],
                            ['30A Monocrystalline AO', '공구강 / 합금강'],
                            ['40A White AO', '모든 종류의 강'],
                            ['50A Pink AO', '공구강 / 베어링강 / 열처리강'],
                            ['60A Ruby AO', '공구강 / 열처리강 (열에 민감)'],
                            ['80A Micro-crystalline AO Blue', '고경도 합금강'],
                            ['90A Micro-crystalline AO White', '고경도 합금강'],
                            ['10C Black Silicon Carbide', '석재 / 대리석 / 고무 / 세라믹'],
                            ['20C Green Silicon Carbide', '초경합금 / 티타늄 / 비철금속'],
                        ]
                    }
                ],
            },
            {
                _id: 'bayunion_4',
                name: '비트리 CBN 휠',
                type: '비트리 CBN 휠',
                url: 'bayunion',
                type_url: 'cbd',
                type_image: 'bay_union_cbd',
                description: 'The application of grinding wheels in cylindrical grinding refers to the process of grinding the outer surface of the workpiece with grinding objects such as grinding wheels to achieve the requirements of dimensional accuracy and surface roughness. Generally speaking, most of the workpieces that need to grind the external surface have multiple angles. Therefore, a grinding machine that clamps and rotates the workpiece is often used with multiple grinding wheels of different angles for grinding operations. And BAY UNION Grinding can plan the grinding wheel specifications according to the customers on-site environment and related conditions, so that customers can be completely assured of the grinding quality after the grinding wheel is installed.',
                details: [
                    {
                        name: '비트리 CBN 휠',
                        image: '/images/product_images/bayunion_images/bayunion_type_images/bay_union_cbd.jpg',
                        alt: 'bayunion',
                        type: 'mounted_wheel',
                        description: 'Key factor: Precision, stability, surface roughness.',
                    }
                ],
            },
            {
                _id: 'bayunion_5',
                name: '추지석',
                type: '추지석',
                url: 'bayunion',
                type_url: 'mounted',
                type_image: 'bay_union_mounted_wheel',
                description: 'The application of grinding wheels in cylindrical grinding refers to the process of grinding the outer surface of the workpiece with grinding objects such as grinding wheels to achieve the requirements of dimensional accuracy and surface roughness. Generally speaking, most of the workpieces that need to grind the external surface have multiple angles. Therefore, a grinding machine that clamps and rotates the workpiece is often used with multiple grinding wheels of different angles for grinding operations. And BAY UNION Grinding can plan the grinding wheel specifications according to the customers on-site environment and related conditions, so that customers can be completely assured of the grinding quality after the grinding wheel is installed.',
                details: [
                    {
                        name: '추지석',
                        image: '/images/product_images/bayunion_images/bayunion_type_images/bay_union_mounted_wheel.jpg',
                        alt: 'bayunion',
                        type: 'mounted_wheel',
                        description: 'Key factor: Precision, stability, surface roughness.',
                        sub_descriptions_title: '연마입자별 표준 적용 예',
                        table_headers: ['연마입자', '작업 적용'],
                        table_content: [
                            ['10A Brown Fused AO', '주철 / 비열처리강'],
                            ['20A Semi-friable AO', '탄소강 / 주철'],
                            ['30A Monocrystalline AO', '공구강 / 합금강'],
                            ['40A White AO', '모든 종류의 강'],
                            ['50A Pink AO', '공구강 / 베어링강 / 열처리강'],
                            ['60A Ruby AO', '공구강 / 열처리강 (열에 민감)'],
                            ['80A Micro-crystalline AO Blue', '고경도 합금강'],
                            ['90A Micro-crystalline AO White', '고경도 합금강'],
                            ['10C Black Silicon Carbide', '석재 / 대리석 / 고무 / 세라믹'],
                            ['20C Green Silicon Carbide', '초경합금 / 티타늄 / 비철금속'],
                        ]
                    }
                ],
            },
        ]
    },
    {
        _id: '6',
        brand: 'Andre',
        url: 'andre',
        description: 'Andre Abrasive Articles(폴란드)는 다양한 종류의 레진본드휠을 전문적으로 생산하는 업체로 스프링연마, 철도레일면마, 주물연마, 베어링연마, 주사침연마, 고속도강 소재의 공구연마, 톱날 및 나이프등의 연마를 위한 높은 가성비의 고품질 연마지석을 생산합니다.',
        image: 'andre',
        type: 'abrasive',
        image_height: '150px',
        image_width: '500px',
        className: 'object-fit',
        partner_url: 'https://www.andreabrasive.com/',
        image_upper_path: 'andre_images',
        image_cover_path: 'andre_type_images',
        products: [
            {
                _id: 'andre_1',
                name: 'Bearing Industry / 베어링 연마지석',
                type: 'Bearing Industry / 베어링 연마지석',
                url: 'andre',
                type_url: 'bearing',
                type_image: 'andre_bearing',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: 'Bearing Industry / 베어링 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_bearing.jpg',
                        alt: 'andre',
                        type: 'bearing_grinding',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_2',
                name: 'Wood Industry / 톱날, 나이프 연마지석',
                type: 'Wood Industry / 톱날, 나이프 연마지석',
                url: 'andre',
                type_url: 'wood',
                type_image: 'andre_wood',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: 'Wood Industry / 톱날, 나이프 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_wood.jpg',
                        alt: 'andre',
                        type: 'wood_grinding',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_3',
                name: 'Rail Industry / 철도레일 연마지석',
                type: 'Rail Industry / 철도레일 연마지석',
                url: 'andre',
                type_url: 'rail',
                type_image: 'andre_rail',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: 'Rail Industry / 철도레일 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_rail.jpg',
                        alt: 'andre',
                        type: 'rail_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_4',
                name: 'Tool Industry / 고속도강 공구 연마지석',
                type: 'Tool Industry / 고속도강 공구 연마지석',
                url: 'andre',
                type_url: 'tool',
                type_image: 'andre_tool',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: 'Tool Industry / 고속도강 공구 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_tool.jpg',
                        alt: 'andre',
                        type: 'tool_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_5',
                name: '주사침 연마지석',
                type: '주사침 연마지석',
                url: 'andre',
                type_url: 'needle',
                type_image: 'andre_needle',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '주사침 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_needle.jpg',
                        alt: 'andre',
                        type: 'tool_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_6',
                name: '주물 연마지석',
                type: '주물 연마지석',
                url: 'andre',
                type_url: 'mold',
                type_image: 'andre_mold',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '주물 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_mold.jpg',
                        alt: 'andre',
                        type: 'mold_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_7',
                name: '스프링 연마지석',
                type: '스프링 연마지석',
                url: 'andre',
                type_url: 'spring',
                type_image: 'andre_spring',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '스프링 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_spring.jpg',
                        alt: 'andre',
                        type: 'mold_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
            {
                _id: 'andre_8',
                name: '곡물 연마지석',
                type: '곡물 연마지석',
                url: 'andre',
                type_url: 'food',
                type_image: 'andre_food',
                description: 'Superfinishing, sometimes called micromachining or short-stroke honing, is a low temperature, low stock removal process.',
                details: [
                    {
                        name: '곡물 연마지석',
                        image: '/images/product_images/andre_images/andre_type_images/andre_food.jpg',
                        alt: 'andre',
                        type: 'food_industry',
                        description: 'The application of grinding wheels in plane grinding refers to the process of grinding the surface of a horizontal workpiece with grinding objects such as grinding wheels to achieve smoothness or different contours and angles. BAY UNION Grinding has developed a variety of high-efficiency grinding wheel products according to the different needs of different customers for workpiece performance, surface roughness, precision requirements or cost orientation, so that customers can obtain the greatest value in the process of using grinding wheels.',
                    }
                ],
            },
        ]
    },
    {
        _id: '7',
        brand: 'Eco Graph',
        url: 'ecograph',
        description: '에코그래프(ECOGRAPH AG)은 고품질 닥터 블레이드를 생산하는 스위스 업체 입니다. Zurich 에서 약 60Km떨어진 지역에 위치해 있습니다. 독자적으로 개발한 모든 기계적, 물리적, 화학적인 기술을 사용한 생산라인에서 비교할 수 없는 고품질의 닥터블레이드를 생산하고 있습니다. 숙련된 기계공학, 화학공학엔지니어들이 새롭게 개발되는 인쇄와 코팅에 적합한 닥터블레이드를 고객의 요구대로 개발, 공급하고 있습니다.',
        image: 'ecograph',
        type: 'printing',
        image_height: '100px',
        image_width: '450px',
        className: 'object-fit',
        partner_url: 'http://www.ecograph.ch/',
        image_upper_path: 'ecograph_images',
        image_cover_path: 'ecograph_type_images',
        products: [
            {
                _id: 'ecoGraph_1',
                name: '다이나믹존 / Dynamic Zone',
                type: '다이나믹존 / Dynamic Zone',
                url: 'ecograph',
                type_url: 'dynamic',
                type_image: 'Dynamic_EcoGraph',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '다이나믹존 / Dynamic Zone',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/Dynamic_EcoGraph.jpg',
                        alt: 'ecograph',
                        type: 'dynamic_zone',
                        description: '라멜라(lamella)날 수평부위의 끝부분부터 블레이드 두께부분까지 부드러운 곡면을 만들어줍니다.'
                    }
                ]
            },
            {
                _id: 'ecoGraph_2',
                name: '연마무늬 / Grinding Pattern',
                type: '연마무늬 / Grinding Pattern',
                url: 'ecograph',
                type_url: 'grinding',
                type_image: 'Grinding_EcoGraph',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '연마무늬 / Grinding Pattern',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/Grinding_EcoGraph.jpg',
                        alt: 'ecograph',
                        type: 'grinding_pattern',
                        description: '미세한 교차 연마결을 갖고있는 에코그래프의 닥터블레이드는 최상의 라멜라 표면품질을 보장 합니다.'
                    }
                ],
            },
            {
                _id: 'ecoGraph_3',
                name: '래핑 / Lapping',
                type: '래핑 / Lapping',
                url: 'ecograph',
                type_url: 'lapping',
                type_image: 'Lapping_EcoGraph',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '래핑 / Lapping',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/Lapping_EcoGraph.jpg',
                        alt: 'ecograph',
                        type: 'lapping_pattern',
                        description: '에코그래프의 (ECOGRAPH)의 완벽하게 래핑 가공이 된 닥터블레이드는 새로 장착 하자 마자 실린더의 잉크나 코팅액을 바로 걷어내 주어 교체할 때마다 소모된 시간 및 재료의 비용을 줄여 줍니다.'
                    }
                ],
            },
            {
                _id: 'ecoGraph_4',
                name: '표준 라멜라 / Lamella Edge',
                type: '표준 라멜라 / Lamella Edge',
                url: 'ecograph',
                type_url: 'lamella',
                type_image: 'ecograph_lamella',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '표준 라멜라 / Lamella Edge',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/ecograph_lamella.jpg',
                        alt: 'ecograph',
                        type: 'lapping_pattern',
                        sub_descriptions: ['뛰어난 선명도의 인쇄 및 코팅 작업', '지속적이고 균일한 인쇄 및 코팅품질', '둥근 날 끝(rounded tip) 형상에 의한 빠른 작업 개시'],
                        table_headers: ['Blade Profile', 'Width (mm)', 'Thickness (mm)', 'Range', 'Standard'],
                        table_content: [
                            ['LAMELLA', 'from 8 to 90', '0.102', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.152 mm: 1.3 x 0.070 mm'],
                            ['LAMELLA', 'from 8 to 90', '0.152', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.152 mm: 1.3 x 0.070 mm'],
                            ['LAMELLA', 'from 8 to 90', '0.203', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.203 mm: 1.3 x 0.100 mm'],
                            ['LAMELLA', 'from 8 to 90', '0.254', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.203 mm: 1.3 x 0.100 mm'],
                            ['LAMELLA', 'from 8 to 90', '0.305', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.254 mm: 1.3 x 0.125 mm'],
                            ['LAMELLA', 'from 8 to 90', '0.381', 'Lamella 0.5 min - 2.5 max mm X from 0.04 mm', 'Thickness 0.254 mm: 1.3 x 0.125 mm'],
                        ]
                    }
                ],
            },
            {
                _id: 'ecoGraph_5',
                name: '베벨 형상/ Bevel Edge',
                type: '베벨 형상/ Bevel Edge', 
                url: 'ecograph',
                type_url: 'bevel',
                type_image: 'ecograph_bevel',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '베벨 형상/ Bevel Edge',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/ecograph_bevel.jpg',
                        alt: 'ecograph',
                        type: 'lapping_pattern',
                        description: '에코그래프의 (ECOGRAPH)의 완벽하게 래핑 가공이 된 닥터블레이드는 새로 장착 하자 마자 실린더의 잉크나 코팅액을 바로 걷어내 주어 교체할 때마다 소모된 시간 및 재료의 비용을 줄여 줍니다.',
                        sub_descriptions: ['높은 압력으로 눌러주는 작업에 적합(날의 휨이 적음)', '다품종 소량 인쇄 및 코팅작업에 적합', '매우 얇은 날 끝(thin rounded tip)에 의한 빠른 작업개시'],
                        table_headers: ['Blade Profile', 'Width (mm)', 'Thickness (mm)', 'Range', 'Standard'],
                        table_content: [
                            ['BEVEL', 'from 8 to 90', '0.102', 'Bevel from 2° to 60°', '4° & 15°'],
                            ['BEVEL', 'from 8 to 90', '0.152', 'Bevel from 2° to 60°', '4° & 15°'],
                            ['BEVEL', 'from 8 to 90', '0.203', 'Bevel from 2° to 60°', '4° & 15°'],
                            ['BEVEL', 'from 8 to 90', '0.254', 'Bevel from 2° to 60°', '4° & 15°'],
                            ['BEVEL', 'from 8 to 90', '0.305', 'Bevel from 2° to 60°', '4° & 15°'],
                            ['BEVEL', 'from 8 to 90', '0.381', 'Bevel from 2° to 60°', '4° & 15°'],
                        ]
                    }
                ],
            },
            {
                _id: 'ecoGraph_6',
                name: '라운드 날 / Round Edges',
                type: '라운드 날 / Round Edges',
                url: 'ecograph',
                type_url: 'round',
                type_image: 'ecograph_round',
                description: '에코그래프(Ecograph AG)는 독창적인 교차연마기술(Cross Grinding Technology)을 사용하여 미세한 표면조도 및 정밀한 치수의 라멜라(lamella)와 바벨(bevel)형태의 날을 가공합니다. 교차연마방식(Cross Grinding Technology CGT)으로 가공된 날은 표면이 매우 매끈하고 연마무늬가 없습니다. 연마무늬(수평 혹은 횡방향)가 있는 블레이드 날은 마모가 빠르며 쉽게 깨짐이 발생하는 원인을 제공합니다. 매끈한 면을 갖고 있는 에코그래프의 닥터블레이드는 균일한 인쇄 및 코팅품질과 긴 수명의 블레이드를 보장 합니다.',
                details: [
                    {
                        name: '라운드 날 / Round Edges',
                        image: '/images/product_images/ecograph_images/ecograph_type_images/ecograph_round.jpg',
                        alt: 'ecograph',
                        type: 'lapping_pattern',
                        description: '에코그래프의 (ECOGRAPH)의 완벽하게 래핑 가공이 된 닥터블레이드는 새로 장착 하자 마자 실린더의 잉크나 코팅액을 바로 걷어내 주어 교체할 때마다 소모된 시간 및 재료의 비용을 줄여 줍니다.',
                        sub_descriptions: ['높은 블레이드 강성', '긴 수명', '느린 작업개시 시간(run-in time) (날 두께에 따라 다름)', '낮은 선수의 아니록스 롤이나 그라비아 흰색 잉크의 베이스(배다) 인쇄 크롬 롤에 적용'],
                        table_headers: ['Blade Profile', 'Width (mm)', 'Thickness (mm)', 'Range', 'Standard'],
                        table_content: [
                            ['ROUND', 'from 8 to 90', '0.065', 'Round', 'radius = 1/2 thickness'],
                            ['ROUND', 'from 8 to 90', '0.076', 'Round', 'radius = 1/2 thickness'],
                            ['ROUND', 'from 8 to 90', '0.102', 'Round', 'radius = 1/2 thickness'],
                            ['ROUND', 'from 8 to 90', '0.152', 'Round', 'radius = 1/2 thickness'],
                            ['ROUND', 'from 8 to 90', '0.203', 'Round', 'radius = 1/2 thickness'],
                            ['ROUND', 'from 8 to 90', '0.254', 'Round', 'radius = 1/2 thickness'],
                        ]
                    }
                ],
            }
        ]
    },
    {
        _id: '8',
        brand: 'ARC International',
        url: 'arc',
        description: 'ARC’s mission is to continue its development and advancement of technically innovative products. Our vision is to be the source for a Totally Integrated Package of Products and Services in the Flexographic Industry.',
        image: 'arc',
        type: 'printing',
        display: 'inline-block',
        height: '225.16px',
        image_height: '100px',
        image_width: '450px',
        className: 'object-fit',
        partner_url: 'https://www.arcinternational.com/',
        image_upper_path: 'arc_images',
        image_cover_path: 'arc_type_images',
        products: [
            {
                _id: 'arc_1',
                name: 'Anilox Roller',
                type: 'Anilox Roller',
                url: 'arc',
                type_url: 'anloxroller',
                type_image: 'AR_AnloxRollr',
                description: 'description',
                details: [
                    {
                        name: 'Anilox Roller',
                        image: '/images/product_images/arc_images/arc_type_images/AR_AnloxRollr.jpg',
                        alt: 'arc',
                        type: 'anilox_roller',
                        description: 'Anilox Roller is this and that'
                    }
                ]
            },
            {
                _id: 'arc_2',
                name: 'Glue and Meter Roller',
                type: 'Glue and Meter Roller',
                url: 'arc',
                type_url: 'glue',
                type_image: 'gluerollWRDS',
                description: 'description',
                details: [
                    {
                        name: 'Glue and Meter Roller',
                        image: '/images/product_images/arc_images/arc_type_images/gluerollWRDS.jpg',
                        alt: 'ecograph',
                        type: 'dynamic_zone',
                        description: 'dynamic zone is this and that'
                    }
                ]
            },
            {
                _id: 'arc_3',
                name: 'Rubber Feed Roller',
                type: 'Rubber Feed Roller',
                url: 'arc',
                type_url: 'rubberFeed',
                type_image: 'AR_ruberFeed',
                description: 'description',
                details: [
                    {
                        name: 'Rubber Feed Roller',
                        image: '/images/product_images/arc_images/arc_type_images/AR_ruberFeed.jpg',
                        alt: 'ecograph',
                        type: 'dynamic_zone',
                        description: 'dynamic zone is this and that'
                    }
                ]
            },
            {
                _id: 'arc_4',
                name: 'Cleaning Pad',
                type: 'Cleaning Pad',
                url: 'arc',
                type_url: 'cleaning_pad',
                type_image: 'ARC_AnlxClnPad',
                description: 'description',
                details: [
                    {
                        name: '1. Dynamic Zone',
                        image: '/images/product_images/arc_images/arc_type_images/ARC_AnlxClnPad.jpg',
                        alt: 'ecograph',
                        type: 'dynamic_zone',
                        description: 'dynamic zone is this and that'
                    }
                ]
            },
        ]
    },
    // {
    //     _id: '9',
    //     brand: 'Tamburini',
    //     url: 'tamburini',
    //     description: 'tamburini',
    //     image: 'tamburini',
    //     type: 'printing',
    //     display: 'inline-block',
    //     height: '225.16px'
    // },
    {
        _id: '10',
        brand: 'Gioria',
        url: 'gioria',
        description: '지오리아(Gioria)는 1962년에 설립된 이태리 업체입니다.',
        image: 'gioria',
        type: 'measurment',
        display: 'inline-block',
        height: '225.16px',
        image_height: '100px',
        image_width: '450px',
        className: 'object-fit',
        partner_url: 'https://www.gioria.com/',
        image_upper_path: 'gioria_images',
        image_cover_path: 'gioria_type_images',
        products: [
            {
                _id: 'gioria_1',
                name: 'RH / N CNC',
                type: 'RH / N CNC',
                url: 'gioria',
                type_url: 'rhncnc',
                type_image: 'gioria_rh',
                description: 'description',
                details: [
                    {
                        name: 'RH / N CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_rh.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '1500', '2000'],
                        table_content: [
                            ['Max.grindable length', 'mm.', '1000', '1500', '2000'],
                            ['Centers height', 'mm.', '', '200', ''],
                            ['Max.grindable diameter', 'mm.', '', '400', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '300', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '450 X 60 X 127', ''],
                            ['Wheelhead motor power', 'kW.', '', '5.5', ''],
                            ['Workhead motor power', 'kW.', '', '3', ''],
                            ['Machine weight (approx.)', 'kg.', '4000', '5000', '6000']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_2',
                name: 'RU / PN CNC',
                type: 'RU / PN CNC',
                url: 'gioria',
                type_url: 'rupncnc',
                type_image: 'gioria_ru',
                description: 'description',
                details: [
                    {
                        name: 'RU / PN CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_ru.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '1500', '2000', '2500', '3000', '3500', '4000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '1000', '1500', '2000', '2500', '3000', '3500', '4000'],
                            ['Centers height', 'mm.', '', '', '', '200/300', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '500/600', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '500/600', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '610x80x203', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '11', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '3,3', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '7000', '8000', '9000', '10000', '11000', '12000', '13000']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_3',
                name: 'RU / S - RU / S CNC',
                type: 'RU / S - RU / S CNC',
                url: 'gioria',
                type_url: 'ruscnc',
                type_image: 'gioria_ru_s',
                description: 'description',
                details: [
                    {
                        name: 'RU / S - RU / S CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_ru_s.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '2000', '3000', '4000', '5000', '6000', '7000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '1000', '2000', '3000', '4000', '5000', '6000', '7000'],
                            ['Centers height', 'mm.', '', '', '', '300/350/400/450', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '600/700/800/900', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '3000', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '762x80/100x304,8', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '20', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '11,5', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '15000', '16500', '18000', '21000', '24000', '27000', '30000']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_4',
                name: 'R/161 CNC',
                type: 'R/161 CNC',
                url: 'gioria',
                type_url: 'rcnc',
                type_image: 'gioria_r',
                description: 'description',
                details: [
                    {
                        name: 'R/161 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '1500', '2000', '2500', '3000', '3500', '4000', '4500', '5000', '6000', '7000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '1000', '1500', '2000', '2500', '3000', '3500', '4000', '4500', '5000', '6000', '7000'],
                            ['Centers height', 'mm.', '', '', '', '', '250 / 300', '', '', '', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '', '500 / 600', '', '', '', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '', '1000', '', '', '', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '', '762x80/100x304,8', '', '', '', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '', '22', '', '', '', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '', '5', '', '', '', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '13900', '14400', '15000', '15600', '16200', '16800', '17500', '18700', '19800', '22000', '24200']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_5',
                name: 'R/162 CNC',
                type: 'R/162 CNC',
                url: 'gioria',
                type_url: 'r162',
                type_image: 'gioria_r_162',
                description: 'description',
                details: [
                    {
                        name: 'R/162 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_162.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '2000', '2500', '3000', '3500', '4000', '4500', '5000', '6000', '7000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '1000', '2000', '2500', '3000', '3500', '4000', '4500', '5000', '6000', '7000'],
                            ['Centers height', 'mm.', '', '', '', '', '300 / 400', '', '', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '', '600 / 800', '', '', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '', '4000', '', '', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '', '762x80/100x304,8', '', '', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '', '22', '', '', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '', '22', '', '', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '19500', '21450', '22400', '23400', '25300', '27300', '29200', '31200', '35100', '39000']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_6',
                name: 'R/163 CNC',
                type: 'R/163 CNC',
                url: 'gioria',
                type_url: 'r163',
                type_image: 'gioria_r_163',
                description: 'description',
                details: [
                    {
                        name: 'R/163 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_163.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '1000', '2000', '3000', '4000', '5000', '6000', '7000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '1000', '2000', '3000', '4000', '5000', '6000', '7000'],
                            ['Centers height', 'mm.', '', '', '400 / 500', '', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '800 / 1000', '', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '8000', '', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '915x80/100x304,8', '', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '37', '', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '37', '', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '31000', '33000', '36300', '40250', '44800', '49500', '54450']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_7',
                name: 'R/150 CNC',
                type: 'R/150 CNC',
                url: 'gioria',
                type_url: 'r150',
                type_image: 'gioria_r_150',
                description: 'description',
                details: [
                    {
                        name: 'R/150 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_150.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '2000', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '2000', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                            ['Centers height', 'mm.', '', '', '', '', '450 / 750', '', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '', '900 / 1500', '', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '', '15000', '', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '', '1016x80/100x304,8', '', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '', '39', '', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '', '37', '', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '37400', '41800', '46200', '50600', '55000', '59400', '64900', '70400', '77000']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_8',
                name: 'R/152 CNC',
                type: 'R/152 CNC',
                url: 'gioria',
                type_url: 'r152',
                type_image: 'gioria_r_152',
                description: 'description',
                details: [
                    {
                        name: 'R/150 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_152.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                            ['Centers height', 'mm.', '', '', '', '500 / 750', '500 / 750', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '1000 / 1500', '1000 / 1500', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '25000', '25000', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '1016x80/100x304,8', '1016x80/100x304,8', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '60', '60', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '60', '60', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '44000', '49500', '55000', '60500', '66000', '71500', '77000', '82500']
                        ]
                    }
                ]
            },
            {
                _id: 'gioria_9',
                name: 'R/154 CNC',
                type: 'R/154 CNC',
                url: 'gioria',
                type_url: 'r154',
                type_image: 'gioria_r_154',
                description: 'description',
                details: [
                    {
                        name: 'R/150 CNC',
                        image: '/images/product_images/gioria_images/gioria_type_images/gioria_r_154.jpg',
                        alt: 'gioria',
                        type: 'machine',
                        description: 'dynamic zone is this and that',
                        table_headers: ['Technical Features', 'Model', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                        table_content: [
                            ['Max. grindable length', 'mm.', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000'],
                            ['Centers height', 'mm.', '', '', '', '750', '750', '', '', ''],
                            ['Max.grindable diameter', 'mm.', '', '', '', '1500', '1500', '', '', ''],
                            ['Max. weight allowed between centers', 'kg.', '', '', '', '40000', '40000', '', '', ''],
                            ['Wheel dimensions Ø x thickness x hole', 'mm.', '', '', '', '1016x80/100x304,8', '1016x80/100x304,8', '', '', ''],
                            ['Wheelhead motor power', 'kW.', '', '', '', '76', '76', '', '', ''],
                            ['Workhead motor power', 'kW.', '', '', '', '63', '63', '', '', ''],
                            ['Machine weight (approx.)', 'kg.', '71500', '77000', '82500', '88000', '94600', '102300', '110000', '117700']
                        ]
                    }
                ]
            },
        ]
    },
    {
        _id: '11',
        brand: 'Innogrind',
        url: 'innogrind',
        description: 'innogrind',
        image: 'innogrind',
        type: 'nozzle',
        display: 'inline-block',
        height: '225.16px',
        image_height: '50px',
        image_width: '175px',
        className: 'object-fit',
        partner_url: 'https://www.innogrind.com/',
        image_upper_path: 'innogrind_images',
        image_cover_path: 'innogrind_type_images',
        products: [
            {
                _id: 'innogrind_1',
                name: 'Standard Nozzle / 기본 노즐',
                type: 'Standard Nozzle / 기본 노즐',
                url: 'innogrind',
                type_url: 'standard',
                type_image: 'innogrind_standard',
                description: 'description',
                details: [
                    {
                        name: 'Standard Nozzle / 기본 노즐',
                        image: '/images/product_images/innogrind_images/innogrind_type_images/innogrind_standard.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        description: '3D 프린팅으로 만들어지는 INNOZL™ STL은 여러 방식으로 만들어질수 있습니다.',
                        table_headers: [
                            'Line',
                            'STL',
                            'Mini'
                        ],
                        table_content: [
                            ['Availability', 'From stock', 'From stock'],
                            ['Widths', '15 – 100 mm', '5 - 20 mm'],
                            ['Heights', '75 mm', '56 mm'],
                            ['Connection', '3/8”', '1/4”'],
                            ['Material', 'Titanium', 'Titanium'],
                            ['Design', 'Compact', 'Compact']
                        ]
                    },
                    {
                        name: 'INNOZL™ STL-TI',
                        image: '/images/product_images/extra_slider_images/innozl_4.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        description: '3D 프린팅으로 만들어지는 INNOZL™ STL은 여러 방식으로 만들어질수 있습니다.',
                        sub_descriptions_title: 'For Connection 3/8"',
                        table_headers: [
                            '', ''
                        ],
                        table_content: [
                            ['INNOZL STL38/75/15/5/2,0TI', 'length 75mm, connection 3/8", width 15mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/20/5/2,0TI', 'length 75mm, connection 3/8", width 20mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/25/5/2,0TI', 'length 75mm, connection 3/8", width 25mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/30/5/2,0TI', 'length 75mm, connection 3/8", width 30mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/40/5/2,0TI', 'length 75mm, connection 3/8", width 40mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/50/5/2,0TI', 'length 75mm, connection 3/8", width 50mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/60/5/2,0TI', 'length 75mm, connection 3/8", width 60mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/80/5/2,0TI', 'length 75mm, connection 3/8", width 80mm, angle 5°, outlet 2,0mm'],
                            ['INNOZL STL38/75/100/5/2,0TI', 'length 75mm, connection 3/8", width 100mm, angle 5°, outlet 2,0mm'],
                        ]
                    },
                    {
                        name: 'INNOZL™ STL-Mini TI',
                        image: '/images/product_images/innogrind_images/innogrind_type_images/innozl_stl_ti.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        description: '3D 프린팅으로 만들어지는 INNOZL™ STL은 여러 방식으로 만들어질수 있습니다.',
                        sub_descriptions_title: 'For Connection 1/4"',
                        table_headers: [
                            '', ''
                        ],
                        table_content: [
                            ['INNOZL STL mini 14/56/5/5/1,6TI', 'length 56mm, connection 1/4", width 5mm, angle 5°, outlet 1,6mm'],
                            ['INNOZL STL mini 14/56/8/5/1,6TI', 'length 56mm, connection 1/4", width 8mm, angle 5°, outlet 1,6mm'],
                            ['INNOZL STL mini 14/56/10/5/1,6TI', 'length 56mm, connection 1/4", width 10mm, angle 5°, outlet 1,6mm'],
                            ['INNOZL STL mini 14/56/12/5/1,6TI', 'length 56mm, connection 1/4", width 12mm, angle 5°, outlet 1,6mm'],
                            ['INNOZL STL mini 14/56/15/5/1,6TI', 'length 56mm, connection 1/4", width 15mm, angle 5°, outlet 1,6mm'],
                            ['INNOZL STL mini 14/56/20/5/1,6TI', 'length 56mm, connection 1/4", width 20mm, angle 5°, outlet 1,6mm'],
                        ]
                    }
                ]
            },
            {
                _id: 'innogrind_2',
                name: 'Custom-made nozzles / 고객 맞춤형 노즐',
                type: 'Custom-made nozzles / 고객 맞춤형 노즐',
                url: 'innogrind',
                type_url: 'custom',
                type_image: 'innogrind_custom',
                description: 'description',
                details: [
                    {
                        name: 'Custom-made nozzles / 고객 맞춤형 노즐',
                        image: '/images/product_images/innogrind_images/innogrind_type_images/innogrind_custom.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        description: '3D 프린팅으로 만들어지는 INNOZL™ STL은 여러 방식으로 만들어질수 있습니다.',
                        sub_descriptions: [
                            'Lower production time without grinding burns',
                            'Quick change nozzle system for uninterrupted grinding operations',
                            'Minimized collision risk thanks to one nozzle set-up',
                            'Available modules: m1-5|m5-10|m10-20|+m20 on request'
                        ]
                    }
                ]
            },
        ]
    },
    {
        _id: '12',
        brand: 'HirtLine',
        url: 'hirtline',
        description: '스텐레스 소재로 제조된 스위스 허트라인(Hirt-Line)은 정밀하게 가공된 노즐(Nozzel) 시스템 제품을 생산 합니다. 허트라인의 노즐들은 뛰어난 내열성 및 내 화학성을 갖고 있으며, 쉽고 다양한 형태 및 위치로 고정 될수 있습니다. 또한, 냉각액의 압력이나 기계의 진동에 의해서도 그 타겟 위치가 움직이지 않아 항상 일정한 목표지점에 냉각 작업을 할수 있습니다.',
        image: 'hirtline',
        type: 'nozzle',
        display: 'inline-block',
        height: '225.16px',
        image_height: '100px',
        image_width: '235px',
        className: 'object-fit',
        partner_url: 'https://www.coolant-hose.com/',
        image_upper_path: 'hirtline_images',
        image_cover_path: 'hirtline_type_images',
        products: [
            {
                _id: 'hirtline_1',
                name: '4 System Sizes / 미국파이프 나사규격',
                type: '4 System Sizes / 미국파이프 나사규격',
                url: 'hirtline',
                type_url: 'system_sizes',
                type_image: 'hirtline_standard',
                description: 'description',
                details: [
                    {
                        name: '4 System Sizes / 미국파이프 나사규격',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_standard.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        sub_descriptions_title: '장점 및 특징',
                        sub_descriptions: [
                            '정밀하고 쉽게 노출 위치를 고정',
                            '100 bar 압력에 안정성',
                            '고온, 화확물, 칩, 압력 및 진동에 견딤',
                            '-30°C  to + 60°C 사용온도 (옵션으로 ES-System은 +300°C 견딤)',
                            '내부식성 스텐레스 소재로 제조',
                            '내마모성, 긴 수명'
                        ],
                        table_headers: [
                            'Type 0',
                            'Type 1',
                            'Type 2',
                            'Type 3'
                        ],
                        table_content: [
                            ['1/8” I.D. Ø3.2mm thread M8ⅹ0.75', '1/4” I.D. Ø5.8mm thread M14ⅹ1.0', '1/2” I.D. Ø11.0mm thread M24ⅹ1.0', '3/4” I.D. Ø19.0mm thread M34ⅹ1.0']
                        ]
                    }
                ]
            },
            {
                _id: 'hirtline_2',
                name: 'Machine Adapter / 장비연결 아답타',
                type: 'Machine Adapter / 장비연결 아답타',
                url: 'hirtline',
                type_url: 'machine_adapter',
                type_image: 'hirtline_machine_adapter',
                description: 'description',
                details: [
                    {
                        name: 'Machine Adapter / 장비연결 아답타',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_machine_adapter.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle',
                        sub_descriptions: [
                            'Pipe thread G1/8”, G1/4”, G3/8”, G1/2”, G3/4”, G1”',
                            'Metric  threads M5×0.8 over M14 ×1.0  to  M20 ×1.5',
                            'Conical threads, Ball head adapters Ø10mm, Ø12mm, Ø1'
                        ]
                    }
                ]
            },
            {
                _id: 'hirtline_3',
                name: 'Basic Elements / 기본 구성요소',
                type: 'Basic Elements / 기본 구성요소',
                url: 'hirtline',
                type_url: 'basic_elements',
                type_image: 'hirtline_basic',
                details: [
                    {
                        name: 'Basic Elements / 기본 구성요소',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_basic.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle'
                    }
                ]
            },
            {
                _id: 'hirtline_4',
                name: 'Nozzles / 노즐',
                type: 'Nozzles / 노즐',
                url: 'hirtline',
                type_url: 'nozzles',
                type_image: 'hirtline_nozzles',
                details: [
                    {
                        name: 'Nozzles / 노즐',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_nozzles.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle'
                    }
                ]
            },
            {
                _id: 'hirtline_5',
                name: 'Elbows / 엘보',
                type: 'Elbows / 엘보',
                url: 'hirtline',
                type_url: 'nozzles',
                type_image: 'hirtline_elbow',
                details: [
                    {
                        name: 'Elbows / 엘보',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_elbow.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle'
                    }
                ]
            },
            {
                _id: 'hirtline_6',
                name: 'Accessories / 악세사리',
                type: 'Accessories / 악세사리',
                url: 'hirtline',
                type_url: 'accessories',
                type_image: 'hirtline_accessories',
                details: [
                    {
                        name: 'Accessories / 악세사리',
                        image: '/images/product_images/hirtline_images/hirtline_type_images/hirtline_accessories.jpg',
                        alt: 'innogrind',
                        type: 'standard_nozzle'
                    }
                ]
            },
        ]
    },
    {
        _id: '13',
        brand: 'AniCheck',
        url: 'anicheck',
        description: 'AniCheck',
        image: 'anicheck',
        type: 'measurment',
        display: 'inline-block',
        height: '158px',
        image_height: '125px',
        image_width: '600px',
        className: 'object-fit',
        partner_url: 'https://www.youtube.com/watch?v=3gQwGjPQElo',
        image_upper_path: 'anicheck_images',
        image_cover_path: 'anicheck_type_images',
        products: [
            {
                _id: 'anicheck_1',
                name: '애니체크 / Anicheck',
                type: '애니체크 / Anicheck',
                url: 'anicheck',
                type_url: 'anicheck',
                type_image: 'anicheck',
                description: '애니체크(Anicheck)는 쉽게 사용할 수 있는 아닐록스 롤 측정기 입니다. 교류와 자기장을 이용하여 아닐록스 롤을 관리할수 있는 애니체크는 쉽게 사용할 수 있는 디자인과 뛰어난 정밀도에 의해 산업 환경에 적합합니다.',
                details: [
                    {
                        name: '아닐록스 롤의 보다 나은 품질 관리는 귀사에 큰 이익을 드립니다.',
                        image: '/images/product_images/anicheck_images/anicheck_type_images/anicheck.jpg',
                        alt: 'anicheck',
                        type: 'measurment',
                        sub_descriptions_title: '',
                        sub_descriptions: [
                            '1) 정기적이고 빠른 아닐록스 롤 체크',
                            '2) 인쇄 품질의 최적화',
                            '3) 작업에 적합한 아닐록스 롤 선택 가능',
                            '4) 일정한 인쇄 품질',
                            '5) 아닐록스 롤 관리의 최적화',
                            '6) 아닐록스 롤의 품질 관리',
                            '7) 잦은 작업중단 없이 생산성 증가',
                            '8) 불량 감소로 인한 비용절감'
                        ]
                    },
                    {
                        name: 'Science Behind Anicheck',
                        image: '/images/product_images/anicheck_images/anicheck_type_images/anicheck_method.jpg',
                        alt: 'anicheck',
                        type: 'measurment',
                        sub_descriptions_title: 'Anicheck은 어떤 방식으로 작동 하나요?',
                        sub_descriptions: [
                            'A: 1) 교류가 코일 안에서 순환 합니다.',
                            'A: 2) 교류가 자기장을 만듭니다.',
                            'A: 3) 이 자기장은 미세한 전류를 소재에 유도 합니다. 프로브는 이 미세 전류를 측정 합니다.',
                            'B: 4) 자기장 입자들은 갖'
                        ]
                    },
                    {
                        name: '타 볼륨 측정 방법들과 애니체크 비교',
                        image: '/images/product_images/anicheck_images/anicheck_type_images/anicheck_graph.jpg',
                        alt: 'anicheck',
                        type: 'measurment',
                        table_headers: ['방법', '가격', '신뢰성', '정확도', '사용의 난이도/실질성'],
                        table_content: [
                            ['기존', '++', '+', '+/- 8%', ' (+) 모든 작업에 사용가능, (-) 긴측정시간'],
                            ['3-D interferometer', '-', '+/-', '+/- 10%', ' (+) 입체 프로파일, (-) 긴측정시간,(-) 특정한 조판에만 사용 가능, (-) 쉽게 파손됨'],
                            ['Anicheck', '+', '++', '+/- 3%', ' (+) 빠른 측정, (+) 강한 내구력, (+) 쉬운 사용법, (+) 모든 작업에 사용 가능, (+) 저렴한 가격'],
                        ]
                    }
                ]
            },
        ]
    }
];

export default PartnerData